<div *ngIf="isLoading" class="spinner-container">
    <mat-spinner [diameter]="50"></mat-spinner>
</div>
<div class="container">
    <div class="heading-container">
        <mat-icon class="icon" (click)="goBack()">arrow_back</mat-icon>
        <p class="heading">{{ "userReviewPage.heading" | translate }}</p>
    </div>
    <div class="product-section" *ngIf="order && !isLoading">
        @for (orderItem of orderItems; track $index) {
        <div class="product">
            <div class="left-section">
                <img class="product-image" [src]="orderItem.product?.images?.imagesUrl?.[0]" />
            </div>
            <div class="right-section">
                <p
                    class="product-name"
                    [matTooltipShowDelay]="800"
                    [matTooltipHideDelay]="500"
                    [matTooltip]="orderItem.product?.name"
                >
                    {{ orderItem.product?.name }}
                </p>
                <div class="star-container">
                    <mat-icon *ngFor="let _ of [].constructor(5)">star_border</mat-icon>
                </div>
                <button
                    class="cancel-btn"
                    mat-flat-button
                    [disabled]="isReviewDisabled(orderItem.product)"
                    (click)="navigateRating(orderItem.id!)"
                >
                    {{ "userReviewPage.button.review" | translate }}
                </button>
            </div>
        </div>
        }
    </div>
</div>

<div class="no-order-container" *ngIf="!order && !isLoading">
    <app-no-order-item></app-no-order-item>
</div>
